import React from 'react';
import { bool, func } from 'prop-types';

import { Button, Container, Typography } from '@ajaibid/components';
import { PopUpCenterV2 } from 'Component/PopUp';

const PopUpAvailableLot = (props) => {
  const { show, onHide } = props;

  return (
    <PopUpCenterV2 size="md" show={show} onHide={onHide} data-testid="popup-availableLot">
      <Container padding="8px 48px 32px">
        <Typography type="body" bold align="center" margin={0}>
          Lot Tersedia
        </Typography>
        <Typography type="body" align="center" marginTop={8}>
          Lot tersedia adalah jumlah lot yang bisa dijual dari seluruh total aset saham di
          portofolio kamu.
        </Typography>
      </Container>
      <Button fluid variant="primary" size="lg" onClick={onHide}>
        Mengerti
      </Button>
    </PopUpCenterV2>
  );
};

PopUpAvailableLot.propTypes = {
  show: bool,
  onHide: func,
};

PopUpAvailableLot.defaultProps = {
  show: false,
  onHide: () => {},
};

export default PopUpAvailableLot;
